import { render, staticRenderFns } from "./Mordenes.vue?vue&type=template&id=c7da566c"
import script from "./Mordenes.vue?vue&type=script&lang=js"
export * from "./Mordenes.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports